function isEven (value) {
    return value % 2 === 0;
}

function formatText (text, modelData) {
    return text && text.replace(/\$\{(.+)\}/g, (...args) => {
        const value = args[1];

        return modelData[value];
    });
}

function capitalizeFirstOfEachWord (str) {
    const arr = str.split(' ');
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(" ");
}

function toFloat (originalValue) {
    let endValue = originalValue;

    if (typeof originalValue !== 'number') {
        const formattedValue = originalValue && originalValue.replace && originalValue.replace(/,/g, '')

        endValue = parseFloat(formattedValue);

        if (isNaN(endValue) || typeof endValue !== 'number') {
            console.warn(`Expected a number, recieved ${originalValue}`);

            endValue = 0;
        }
    }

    return endValue;
};

function toPercent (value) {
    const floatValue = toFloat(value);

    return `${floatValue.toFixed(2)}%`;
}

function toDollars (value) {
    const floatValue = toFloat(value);

    return `$${floatValue.toFixed(2)}`;
}


function scrubNumbers (value) {
    if (value === undefined) {
      value = ''
    }
    return value.replace(/,/g,'')
}

function formatNumbers (value) {
    //console.log(value)
    const parts = value.toString().split('.');
    const wholes = parts[0];
    const decimals = parts[1];
    const wholesLength = wholes.length;
    const hasDecimal = decimals !== undefined;

    let newWholes = '';

    // Add commas every reverse three characters
    for (let i = 0; i < wholesLength; i++) {
        const reverseIndex = wholesLength - i;

        if (i && reverseIndex % 3 === 0) {
            newWholes += ',';
        }

        newWholes += wholes[i];
    }

    const decimalValue = hasDecimal ? `.${decimals}` : '';
    // Bingo Bango - Formatted as a decimal
    value = `${newWholes}${decimalValue}`;
    //console.log(value)
    return value;
}

function dateString () {
    const d         = new Date()
    const year      = String(d.getFullYear())
    const month     = String(d.getMonth()+1).padStart(2, '0')
    const day       = String(d.getDate()).padStart(2, '0')
    const secs      = String(d.getSeconds())
    return year.concat('', month.concat('', day.concat('', secs)));
}


function findLatestDatedRecord (array, dateField) {
    if (!array || array.length === 0) {
        return undefined
    }
    
    return array.reduce((latest, current) => {
        const latestDate = new Date(latest[dateField])
        const currentDate = new Date(current[dateField])

        return currentDate > latestDate ? current : latest
    })
}


function formatBigInt (value, showFull = false, spellOut = false) {
    let parsed = Number((value + '').replace(/[^0-9.]/g, ''))
    if (isNaN(parsed)) return value

    const isTho = value >= 100000 && value < 1000000
    const isMil = value >= 1000000 && value < 1000000000
    const isBil = value >= 1000000000 && value < 1000000000000
    const isTril = value >= 1000000000000
                           
    const denominator = isTho ? 1000 : isMil ? 1000000 : isBil ? 1000000000 : isTril ? 1000000000000 : 0;

    // if the ending digit is a zero, don't show it
    const digitCount = (parsed / denominator).toFixed(2).toString().split('').pop() == 0 ? 1 : 2
  
    parsed = (isTho || isMil || isBil || isTril) && !showFull ? (parsed / denominator).toFixed( digitCount ) : parsed.toFixed(2)
  
    const indexDecimal = parsed.indexOf('.')
    const valDecimal = indexDecimal !== -1 ? Number(parsed.slice(indexDecimal + 1)) : ''
  
    if (indexDecimal !== -1) parsed = parsed.slice(0, indexDecimal)
  
    const chunks = Math.floor(parsed.length / 3)
    const firstChunk = parsed.length % 3
  
    const main = []
    if (firstChunk) main.push(parsed.slice(0, firstChunk))
    for (let i = 0; i < chunks; i++) {
      main.push(parsed.slice(firstChunk + (i * 3), firstChunk + (i * 3) + 3))
    }
  
    return `$${main.join(',')}${valDecimal ? '.' + valDecimal : ''}${isTho && !showFull ? spellOut ? ' Thousand' : ' K' : isMil && !showFull ? spellOut ? ' Million' : ' M' : isBil && !showFull ? spellOut ? ' Billion' : ' B' : isTril && !showFull ? spellOut ? ' Trillion' : ' T' : ''}`
}

function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}

function generateUUID() {
    // UUID v4 generation (random)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export {
    isEven,
    formatText,
    formatNumbers,
    scrubNumbers,
    formatBigInt,
    toFloat,
    toPercent,
    toDollars,
    dateString,
    formatPhoneNumber,
    findLatestDatedRecord,
    capitalizeFirstOfEachWord,
    generateUUID
};


// WEBPACK FOOTER //
// ./src/helpers/utilities.js